import React from 'react';
import Flatpickr from 'react-flatpickr';
import cn from 'classnames';
import 'flatpickr/dist/flatpickr.css';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { ReactComponent as CalendarIcon } from 'assets/img/icons/calendar.svg';

/**
 * @description Flatpicker docs: https://flatpickr.js.org/
 * @param {import('react-flatpickr').DateTimePickerProps & {
 *   innerRef: React.RefObject<HTMLInputElement>,
 *   label: string,
 *   caption: string,
 *   tooltipText: string,
 *   value: string | number | Date | (string | number | Date)[],
 *   error: string,
 *   disabled: boolean,
 *   placeholder: string,
 *   className: string,
 *   inputWrapClassName: string,
 *   flatpickerProps: import('react-flatpickr').FlatpickrOptions
 * }} props
 */
export default function DatePicker({
  innerRef = null,
  label = '',
  caption = '',
  tooltipText = '',
  value = null,
  onChange = () => {},
  error = '',
  disabled = false,
  placeholder = 'Select Date',
  className = '',
  inputWrapClassName = '',
  ...flatpickerProps
}) {
  return (
    <Flatpickr
      ref={innerRef}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
      {...flatpickerProps}
      render={(props, ref) => (
        <UiKit.Input
          {...props}
          bypassReadMode
          inputRef={ref}
          error={error}
          label={label}
          caption={caption}
          tooltipText={tooltipText}
          className={cn(styles.container, className)}
          inputWrapperClassName={cn(styles.inputWrapper, inputWrapClassName)}
        >
          <CalendarIcon className={styles.icon} />
        </UiKit.Input>
      )}
    />
  );
}
